import { loadingAsyncState } from "widgets-for-react";
import { fetchRecentNews } from "./recentNewsBlockApi";
export const initialState = (props)=>({
        items: loadingAsyncState(fetchRecentNews(props.count))
    });
